module.exports = __webpack_public_path__ + "static/media/band-aid.2e6341b7.svg";